<tt-page *ngIf="!!deviationTypeKeyno">
    <tt-deviation-type [deviationTypeKeyno]="deviationTypeKeyno" (onSave)="onDeviationTypeSave()" (onDelete)="onDeviationTypeDelete()"></tt-deviation-type>
</tt-page>
